<main class="projects-page">

    <!-- PAGE HEADER -->
    <section class="projects-header">

        <div class="projects-header-left">
            <h1 class="projects-title">Projelerim</h1>

            <p class="projects-subtitle">
                Tüm projelerinizi buradan görüntüleyebilir, yönetebilir
                ve yeni projeler oluşturabilirsiniz.
            </p>
        </div>

        @if (projects.length) {
            <button
                type="button"
                class="btn-create-project"
                (click)="createProject()">

                <i class="bi bi-plus-lg"></i>

                <span>
                    Yeni Proje Oluştur
                </span>

            </button>
        }

    </section>


    <!-- VIEW SWITCH -->
    <section class="view-switch">

        <button
            type="button"
            class="view-switch-btn"
            [class.active]="viewMode === 'card'"
            (click)="setViewMode('card')">

            <i class="bi bi-grid-3x3-gap-fill"></i>

            Kart Görünümü

        </button>

        <button
            type="button"
            class="view-switch-btn"
            [class.active]="viewMode === 'application'"
            (click)="setViewMode('application')">

            <i class="bi bi-list-ul"></i>

            Uygulama Bazlı

        </button>

    </section>


    <!-- ========================================================= -->
    <!-- EMPTY STATE -->
    <!-- ========================================================= -->

    @if (projects.length === 0) {

        <section class="empty-projects-area">

            <div class="empty-background-art">

                <div class="ghost-window ghost-window-1"></div>
                <div class="ghost-window ghost-window-2"></div>

                <div class="empty-float-icon empty-float-icon-left">
                    <i class="bi bi-pie-chart-fill"></i>
                </div>

                <div class="empty-float-icon empty-float-icon-right">
                    <i class="bi bi-image"></i>
                </div>

                <div class="paper-plane">
                    <i class="bi bi-send-fill"></i>
                </div>

                <div class="flight-line flight-line-left"></div>
                <div class="flight-line flight-line-right"></div>

            </div>


            <!-- CREATE PROJECT PANEL -->
            <div class="new-project-panel">

                <div class="new-project-panel-header">

                    <h2>
                        Yeni bir proje oluştur
                    </h2>

                    <p>
                        Nasıl başlamak istersiniz?
                    </p>

                </div>


                <div class="new-project-options">

                    <!-- BLANK PROJECT -->
                    <button
                        type="button"
                        class="project-create-option"
                        (click)="createBlankProject()">

                        <div class="project-create-icon blank-project-icon">
                            <i class="bi bi-plus-lg"></i>
                        </div>

                        <div class="project-create-title">
                            Boş proje
                        </div>

                        <div class="project-create-description">
                            Sıfırdan başla
                        </div>

                    </button>


                    <!-- TEMPLATE -->
                    <button
                        type="button"
                        class="project-create-option"
                        (click)="createFromTemplate()">

                        <div class="project-create-icon template-project-icon">
                            <i class="bi bi-rocket-takeoff-fill"></i>
                        </div>

                        <div class="project-create-title">
                            Şablon kullan
                        </div>

                        <div class="project-create-description">
                            Kütüphaneden seç
                        </div>

                    </button>


                    <!-- IMPORT -->
                    <button
                        type="button"
                        class="project-create-option"
                        (click)="importProject()">

                        <div class="project-create-icon import-project-icon">
                            <i class="bi bi-file-earmark-spreadsheet-fill"></i>

                            <span class="import-plus">
                                +
                            </span>
                        </div>

                        <div class="project-create-title">
                            İçe aktar
                        </div>

                        <div class="project-create-description">
                            Başka bir araçtan ekle
                        </div>

                    </button>

                </div>

            </div>


            <div class="empty-project-info">

                <h3>
                    Henüz projeniz yok
                </h3>

                <p>
                    İş fikirlerinizi gerçeğe dönüştürmek için ilk projenizi oluşturun.
                    <br>
                    Projeleriniz burada listelenecek.
                </p>

            </div>

        </section>

    }


    <!-- ========================================================= -->
    <!-- PROJECTS EXIST -->
    <!-- ========================================================= -->

    @if (projects.length > 0) {

        <!-- ===================================================== -->
        <!-- CARD VIEW -->
        <!-- ===================================================== -->

        @if (viewMode === 'card') {

            <section class="projects-panel">

                <div class="projects-panel-header">

                    <div class="projects-panel-title-wrapper">

                        <div class="projects-panel-icon">
                            <i class="bi bi-grid-fill"></i>
                        </div>

                        <h2>
                            Tüm Projeler
                        </h2>

                        <span class="project-count">
                            {{ filteredProjects.length }} proje
                        </span>

                    </div>


                    <div class="projects-panel-actions">

                        <div class="project-search">

                            <i class="bi bi-search"></i>

                            <input
                                type="text"
                                placeholder="Proje ara..."
                                [(value)]="searchText"
                                (input)="onSearch($event)">

                        </div>


                        <select
                            class="project-sort"
                            [value]="sortType"
                            (change)="onSortChange($event)">

                            <option value="lastOpened">
                                Son Açılma Tarihi
                            </option>

                            <option value="name">
                                Proje Adı
                            </option>

                            <option value="type">
                                Proje Tipi
                            </option>

                        </select>

                    </div>

                </div>


                <div class="projects-grid">

                    @for (project of filteredProjects; track project.id) {

                        <article class="project-card">

                            <!-- COVER -->
                            <div class="project-cover">

                                <img
                                    [src]="project.applicationInfo?.logo"
                                    [alt]="project.applicationInfo?.name"
                                    (error)="onImageError($event)">

                                <div
                                    class="project-cover-overlay"
                                    [class.dark]="project.darkCover">

                                    <span class="project-cover-brand">
    {{ project.applicationInfo?.vendorName }}

    <i
        class="bi bi-patch-check-fill project-vendor-verified"
        title="Doğrulanmış yayıncı"
        aria-label="Doğrulanmış yayıncı">
    </i>
</span>

                                    <strong>
                                        {{ project.coverTitle }}
                                    </strong>

                                    <small>
                                        {{ project.coverSubtitle }}
                                    </small>

                                </div>

                                    <div class="project-statistics">
    <span class="project-statistic">
        <i class="bi bi-cursor" title="Toplam tıklama sayısı"></i>
        <strong>12.480</strong>
    </span>
    <span class="project-statistic">
        <i class="bi bi-people" title="Ziyaretçi sayısı"></i>
        <strong>3.260</strong>
    </span>
    <span class="project-statistic">
        <span class="project-statistic-pie" title="Yüzdelik oran: %75" aria-label="Yüzdelik oran: %75"></span>
        <strong>%75</strong>
    </span>
</div>
                                <button
                                    type="button"
                                    class="project-more-btn"
                                    (click)="openProjectMenu(project)">

                                 <i [class]="project.icon || 'bi bi-three-dots'" [style.color]="project.color || null"></i>

                                </button>

                            </div>


                            <!-- CONTENT -->
                            <div class="project-card-content">

                                <div class="project-name-area">

                                    <h3>
                                        {{ project.name }}
                                    </h3>

                                    <p>
                                        {{ project.description }}
                                    </p>

                                </div>


                                <div class="project-meta">

                                    <div class="project-meta-row">

                                        <div class="project-meta-label">
                                            <i class="bi bi-layers"></i>
                                            <span>Proje Tipi</span>
                                        </div>

                                        <strong>
                                            {{ project.applicationInfo?.applicationTypeText }}
                                        </strong>

                                    </div>


                                    <div class="project-meta-row">

                                        <div class="project-meta-label">
                                            <i class="bi bi-calendar3"></i>
                                            <span>Son Açılma</span>
                                        </div>

                                        <strong>
                                            {{ project.lastIncommingDataDate }}
                                        </strong>

                                    </div>


                                    <div class="project-meta-row">

                                        <div class="project-meta-label">
                                            <i class="bi bi-people"></i>
                                            <span>Ekip</span>
                                        </div>

                                        <strong>
                                            {{ project.memberCount }} kişi
                                        </strong>

                                    </div>

                                </div>


                                <div class="project-status">

                                    <span
                                        class="status-dot"
                                               [class.status-green]="project.readyType === AvailabilityStatus.Available"
                                                    [class.status-blue]="project.readyType === AvailabilityStatus.Private"
                                                    [class.status-orange]="project.readyType === AvailabilityStatus.Beta"
                                                    [class.status-gray]="project.readyType === AvailabilityStatus.Error">
                                    </span>

                                    <span>
                                        {{ project.status }}
                                    </span>

                                </div>


                                <div class="project-card-actions">

                                    <button
                                        type="button"
                                        class="project-info-btn"
                                        (click)="openProjectInfo(project)">

                                        <i class="bi bi-info-circle"></i>

                                        Info

                                    </button>

                                    <button
                                        type="button"
                                        class="project-open-btn"
                                        (click)="openProject(project)">

                                        <i class="bi bi-box-arrow-up-right"></i>

                                        Aç

                                    </button>

                                </div>

                            </div>

                        </article>

                    }

                </div>


                @if (filteredProjects.length === 0) {

                    <div class="no-search-result">

                        <i class="bi bi-search"></i>

                        <h3>
                            Proje bulunamadı
                        </h3>

                        <p>
                            Arama kriterlerinize uygun bir proje bulunamadı.
                        </p>

                    </div>

                }

            </section>

        }


        <!-- ===================================================== -->
        <!-- APPLICATION VIEW -->
        <!-- ===================================================== -->

        @if (viewMode === 'application') {

            <section class="application-panel">

                <div class="application-panel-header">

                    <div class="application-panel-title">

                        <div class="application-title-icon">
                            <i class="bi bi-list-ul"></i>
                        </div>

                        <div>
                            <h2>
                                Uygulama Bazlı Listeleme
                            </h2>

                            <p>
                                Projeleriniz, kullandıkları uygulamalara göre
                                gruplandırılmış şekilde görüntülenir.
                            </p>
                        </div>

                    </div>


                    <div class="project-search application-search">

                        <i class="bi bi-search"></i>

                        <input
                            type="text"
                            placeholder="Proje ara..."
                            [(value)]="searchText"
                            (input)="onSearch($event)">

                    </div>

                </div>


                <div class="application-grid">

                    @for (group of applicationGroups; track group.name) {

                        <article class="application-group-card">

                            <div class="application-group-header">

                                <div class="application-group-header-left">

                                    <div
                                        class="application-group-icon"
                                        [style.background]="group.iconBackground"
                                        [style.color]="group.iconColor">

                                        <i [class]="group.icon"></i>

                                    </div>

                                    <h3>
                                        {{ group.name }}
                                    </h3>

                                </div>

                                <span class="application-count">
                                    {{ group.projects.length }}
                                </span>

                            </div>


                            <div class="application-project-list">

                                @for (project of group.projects; track project.id) {

                                    <button
                                        type="button"
                                        class="application-project-item"
                                        (click)="openProject(project)">

                                        <div class="application-project-image">

                                            <img
                                                [src]="project.imageUrl"
                                                [alt]="project.name"
                                                (error)="onImageError($event)">

                                        </div>


                                        <div class="application-project-info">

                                            <strong>
                                                {{ project.name }}
                                            </strong>

                                            <span>

                                                <i
                                                    class="application-status-dot"
                                                    [class.status-green]="project.readyType === AvailabilityStatus.Available"
                                                    [class.status-blue]="project.readyType === AvailabilityStatus.Private"
                                                    [class.status-orange]="project.readyType === AvailabilityStatus.Beta"
                                                    [class.status-gray]="project.readyType === AvailabilityStatus.Error">
                                                </i>

                                                {{ project.lastOpenedText }}

                                            </span>

                                        </div>


                                        <i class="bi bi-three-dots application-project-more"></i>

                                    </button>

                                }

                            </div>


                            <button
                                type="button"
                                class="application-view-all"
                                (click)="openApplicationGroup(group)">

                                Tüm {{ group.name }} Projelerini Gör

                                <i class="bi bi-arrow-right"></i>

                            </button>

                        </article>

                    }

                </div>

            </section>

        }

    }

</main>